import React from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Button, Alert, Stack } from "@curves/ui-base";
import useCustomerApi from "@apis/useCustomerApi";
import { isFunction } from "@util/utils";

// 新增成為顧客無效
const AddInvalidDialog = React.forwardRef((props, ref) => {
	const { onClose: propsOnClose, open, sourceData = { list: [], typeText: "" }, refresh: refreshProps } = props;
	if (!open) return null;
	const length = sourceData.list.length;
	const { putCustomersJoinInvalidApi } = useCustomerApi();
	const handleCloseOnClick = () => {
		propsOnClose(null);
	};

	const handleSendOnClick = () => {
		const params = {
			customerIDs: sourceData.list,
		};
		doAddInvaludApi(params);
	};

	const doAddInvaludApi = async params => {
		const resp = await putCustomersJoinInvalidApi(params);
		if (resp) {
			isFunction(refreshProps) && refreshProps();
			propsOnClose(null);
		} else {
			console.error(resp);
		}
	};

	return (
		<Dialog open={open} fullWidth>
			<GradientColorHeader onClose={handleCloseOnClick}>加入無效</GradientColorHeader>
			<DialogContent dividers>
				<Grid container>
					<Grid item xs={12}>
						<Alert color="warning" severity="invalid" variant="filled" className="my-2">
							{`將有 ${length} 筆${sourceData.typeText}狀態改為無效${sourceData.typeText}?`}
						</Alert>
					</Grid>
					<Grid item xs={12}>
						<Stack justifyContent="center">
							<Button size="large" variant="contained" color="warning" onClick={handleSendOnClick}>
								確定
							</Button>
						</Stack>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
});

export default AddInvalidDialog;
